import React from 'react';
import {CommonService} from "../../services";
import {ImageConfig} from "../../../constants";
import { ToastComponent } from "t-react-toast";

interface AlertComponentProps {

}

const AlertComponent = (props: AlertComponentProps) => {

    return (
        <ToastComponent position={CommonService._alert.AlertPosition}/>
    )
};

export default AlertComponent;

export const AlertCloseButton = ({...props}: any) => {
    return <span className="toast-close-btn"
                 {...props}
                 id={"toast-close-btn"}
    >
            <ImageConfig.ToastCloseIcon/>
    </span>
};

